/**
 * Vuex "spaces" module (registered as `channels` in the root store).
 *
 * Aggregates channel/space data, the current channel list, and following-list
 * management: state (store.js), actions (operations.js), getters
 * (selectors.js), and mutations (updates.js).
 */
import state from "./store";
import mutations from "./updates";
import getters from "./selectors";
import actions from "./operations";

export default {
  namespaced: true,
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
};
